export function trackEvent(eventName, params = {}) {
    try {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("event", eventName, params);
        }
    } catch (error) {
        console.log("Erro ao disparar analytics:", error);
    }
}